import React, { useState } from 'react';
import axios from 'axios';
import './Analysis.css';
import ClarificationPopup from './ClarificationPopup.js';

const Clarification = ({ setDisplayClarificationPopup, setClarificationContent, setClarificationText, textBody }) => {
    const [highlightedText, setHighlightedText] = useState('');
    const [popupOpen, setpopupOpen] = useState(false);
    const [clarification, setClarification] = useState('');
    const [loadingAPI, setloadingAPI] = useState(false);
    const [error, setError] = useState('');

    const handleHighlightedText = async () => {
        const text = window.getSelection().toString();
        if (text){
            setHighlightedText(text);
            setClarificationText(text);
            setloadingAPI(true);
            setError('');
            try {
                const response = await axios.post('/api/v1/clarification', { text });
                setClarification(response.data.toc_clarify.content);
                setClarificationContent(response.data.toc_clarify.content);
                setDisplayClarificationPopup(true);
                setpopupOpen(true);
            }
            catch (err){
                setError('Couldnt get the clarification.');
            }
            finally {
                setloadingAPI(false);
            }
            
        }
    };

    const handleNewClarification = () => {
        fetchClarification(highlightedText);
    };

    const closePopup = () => {
        setpopupOpen(false);
    }

    
    const fetchClarification = async (text) => {
        setloadingAPI(true);
        setError('');
        try {
            const response = await axios.post('/api/v1/clarificationRoutes', { text });
            setClarification(response.data.toc_clarify.content);
            setpopupOpen(true);
        }
        catch (err){
            setError('Couldnt get the clarification.');
        }
        finally {
            setloadingAPI(false);
        }
    };
    /*
    const handleNewClarification = () => {
        fetchClarification(highlightedText);
    };

    */
    return (
        <div onMouseUp={handleHighlightedText}>
            <p className="documenText">Highlight text for further clarification</p>
            
            {textBody}

            <ClarificationPopup
                open={popupOpen}
                highlightedText={highlightedText}
                clarification={clarification}
                loadingAPI={loadingAPI}
                error={error}
                onClose={closePopup}
                onRefresh={handleNewClarification}
            />
        </div>
    );

/*
    return (
        <div>
            <button onClick={handleHighlightedText}>Highlight text for further clarification</button>
            {popupOpen && (
                <div className="backgroundPopup">
                    <div className="contentPopup">
                        <button className='close' onClick={() => setpopupOpen(false)}>&times;</button>
                        <h2>Clarification:</h2>
                        <p><strong>Highlighted Text:</strong> {highlightedText}</p>
                        <button onClick={() => fetchClarification(highlightedText)}>Get Clarification</button>
                        {loadingAPI ? (
                            <p>Loading content...</p>
                        ) : error ? (
                            <p>{error}</p>
                        ) : (
                            <div className='clarification-content'>
                                <p><strong>Clarification:</strong> {clarification}</p>
                                <button onClick={handleNewClarification}>Refresh clarification</button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
*/
};
export default Clarification;